import { useQuery } from '@tanstack/react-query';
import { fetchContactById } from '../services/contacts';

export const useContact = (token, contactId, initialData) =>
  useQuery({
    queryKey: ['contact', contactId],
    enabled: !!token && !!contactId,
    queryFn: () => fetchContactById(token, contactId),
    initialData: initialData || undefined,
    placeholderData: initialData || undefined,
    staleTime: 0,
    refetchOnMount: 'always',
    refetchOnWindowFocus: 'always',
    retry: false,
  });
